import { BKJSideModal } from 'components/BKJSideModal';
import { FC, useMemo } from 'react';
import {
  CustomerLocationsModalUIProvider,
  useCustomerLocationsModalUIContext,
} from './CustomerLocationsModal.ui.context';
import { CustomerLocationsComponentMap } from './CustomerLocationsModal.constants';
import { customerLocationsModalRoutingService } from './CustomerLocationsModalRouting.constants';

export const CustomerLocationsModalComponent: FC = () => {
  const { isOpen, customerLocationsActiveModalView } = useCustomerLocationsModalUIContext();

  const Component = useMemo(
    () =>
      CustomerLocationsComponentMap[
        customerLocationsActiveModalView as keyof typeof CustomerLocationsComponentMap
      ],
    [customerLocationsActiveModalView],
  );

  return (
    <BKJSideModal
      isOpen={isOpen}
      onClose={customerLocationsModalRoutingService.close}
      headerComponent={'Locations'}
      showBackButton={true}
      onBack={customerLocationsModalRoutingService.close}
    >
      {isOpen && <Component />}
    </BKJSideModal>
  );
};

export const CustomerLocationsModal: FC = () => {
  return (
    <CustomerLocationsModalUIProvider>
      <CustomerLocationsModalComponent />
    </CustomerLocationsModalUIProvider>
  );
};
